import styled from 'styled-components';
import { Text } from '../../../components/Text/Text';
import { SideNavContextProvider } from './SideNavContext';
import { View } from '../../../components/View';
import { HR } from '../HR/HR';
import { Children } from 'react';
// import I18n from 'I18n';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const Ul = styled.ul.withConfig({
  displayName: "SideNav__Ul",
  componentId: "sc-6yaux0-0"
})(({
  depth,
  theme: _theme
}) => {
  const theme = _theme;
  return {
    listStyle: 'none',
    paddingLeft: 0,
    marginTop: theme.space['0'],
    lineHeight: theme.typography['detail-200'].lineHeight,
    marginBottom: depth === 0 ? 0 : undefined
  };
});
const Nav = styled.nav.withConfig({
  displayName: "SideNav__Nav",
  componentId: "sc-6yaux0-1"
})([""]);
export const SideNav = ({
  'aria-label': ariaLabel,
  children,
  depth = 0,
  divider = false,
  headingText,
  value
}) => {
  const isTopLevelNav = depth === 0;
  const computedAriaLabel = ariaLabel || headingText;
  // This string is not available yet.
  // || I18n.text('ui.UISideNav.navigationLandmark');

  return /*#__PURE__*/_jsxs(SideNavContextProvider, {
    depth: depth,
    value: value,
    children: [divider && /*#__PURE__*/_jsx(View, {
      paddingBlockEnd: "200",
      children: /*#__PURE__*/_jsx(HR, {
        distance: "sm"
      })
    }), /*#__PURE__*/_jsxs(Nav, {
      "aria-label": computedAriaLabel,
      as: isTopLevelNav ? 'nav' : 'div',
      children: [headingText && /*#__PURE__*/_jsx(View, {
        paddingBlockEnd: "200",
        children: /*#__PURE__*/_jsx(Text, {
          as: "h5",
          children: headingText
        })
      }), /*#__PURE__*/_jsx(Ul, {
        depth: depth,
        children: Children.map(children, child => {
          if (!child) {
            return null;
          }
          return child;
        })
      })]
    })]
  });
};